import { render, staticRenderFns } from "./order_item.vue?vue&type=template&id=14229c96&scoped=true&"
import script from "./order_item.vue?vue&type=script&lang=js&"
export * from "./order_item.vue?vue&type=script&lang=js&"
import style0 from "./order_item.vue?vue&type=style&index=0&id=14229c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14229c96",
  null
  
)

export default component.exports